module.exports = __webpack_public_path__ + "static/img/position3.61fdba04.png";